import React, { useState, useRef } from 'react';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';
import { exportFamilyConfig, importFromJSON } from '../../../utils/exportUtils';

const BackupRestoreControls = ({ familyMembers, preferences, onRestore }) => {
  const [showMenu, setShowMenu] = useState(false);
  const fileInputRef = useRef(null);

  const handleExportConfig = () => {
    exportFamilyConfig(familyMembers, preferences);
    setShowMenu(false);
  };

  const handleImportClick = () => {
    fileInputRef?.current?.click();
    setShowMenu(false);
  };

  const handleFileChange = (e) => {
    const file = e?.target?.files?.[0];
    if (!file) return;

    importFromJSON(file, (data, error) => {
      if (error) {
        alert(`Import failed: ${error}`);
        return;
      }

      // Validate data structure
      if (!data?.familyMembers || !Array.isArray(data?.familyMembers)) {
        alert('Invalid configuration file format');
        return;
      }

      const confirmRestore = window.confirm(
        `This will restore ${data?.familyMembers?.length} family members and preferences from ${new Date(data?.exportDate)?.toLocaleDateString()}. Continue?`
      );

      if (confirmRestore) {
        onRestore(data);
      }
    });

    // Reset input
    e.target.value = '';
  };

  return (
    <div className="relative">
      <Button
        variant="outline"
        iconName="database"
        onClick={() => setShowMenu(!showMenu)}
      >
        Backup/Restore
      </Button>

      <input
        ref={fileInputRef}
        type="file"
        accept=".json"
        onChange={handleFileChange}
        className="hidden"
      />

      {showMenu && (
        <>
          <div 
            className="fixed inset-0 z-40" 
            onClick={() => setShowMenu(false)}
          />
          <div className="absolute right-0 mt-2 w-56 bg-white rounded-lg shadow-lg border border-border z-50">
            <div className="py-2">
              <button
                onClick={handleExportConfig}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
              >
                <Icon name="download" size={16} />
                Export Configuration
              </button>
              <button
                onClick={handleImportClick}
                className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50 flex items-center gap-2"
              >
                <Icon name="upload" size={16} />
                Import Configuration
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default BackupRestoreControls;